import React, {useState, useEffect} from 'react'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../_metronic/helpers'
import {LoadingData} from '../../../components/LoadingData'
import {useAuth} from '../../modules/auth'
import {ModeleMotif} from '../../../components/Models'
import {deleteMotif, getRefusMotif} from '../../../components/requests'
import Swal from 'sweetalert2'
import {Pagination} from '../../../components/Pagination'

const MotifRefusListPage = () => {
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Array<ModeleMotif>>([])
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)

  useEffect(() => {
    getRefusMotifs()
  }, [currentPage])

  const getRefusMotifs = () => {
    setLoading(true)
    getRefusMotif(currentPage)
      .then((motifRequest) => {
        setNombreDePages(motifRequest?.pages)
        setTotalPages(motifRequest?.total)
        setCurrentPage(motifRequest?.page)
        if (motifRequest?.data !== undefined) {
          setData(motifRequest?.data)
          setLoading(false)
        }
      })
      .catch((e) => {
        setLoading(false)
        console.error(e)
      })
  }

  const removeMotif = async (motifId) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        setLoading(true)
        deleteMotif(motifId).then((response) => {
          if (response?.status === 200) {
            setLoading(false)
            getRefusMotifs()
          }
        })
      }
    })
  }

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5 justify-content-end'>
              {shouldDisplayFonctionnalite(currentUser, 'AJOUTER MOTIF REFUS') && (
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title='Click to add a genre'
                >
                  <Link to={`/motif-refus/ajouter`} className='btn btn-sm btn-light-primary'>
                    <KTIcon iconName='plus' className='fs-3' />
                    Créer un motif
                  </Link>
                </div>
              )}
            </div>
            {/* end::Header */}
            {loading ? (
              <LoadingData />
            ) : (
              <>
                {shouldDisplayFonctionnalite(currentUser, 'VOIR MOTIF REFUS') && (
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-140px'>Libellé</th>
                            <th className='min-w-100px text-end'>Actions</th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {data.length ? (
                            data.map((motif) => {
                              return (
                                <tr key={motif.id}>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='d-flex justify-content-start flex-column'>
                                        {motif.libelle}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='d-flex justify-content-end flex-shrink-0'>
                                      {shouldDisplayFonctionnalite(
                                        currentUser,
                                        'MODIFIER MOTIF REFUS'
                                      ) && (
                                        <Link
                                          to={`/motif-refus/${motif.id}/modifier`}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i className='bi bi-pencil-square fs-2'></i>
                                        </Link>
                                      )}
                                      {shouldDisplayFonctionnalite(
                                        currentUser,
                                        'SUPPRIMER MOTIF REFUS'
                                      ) &&
                                        !motif?.isUsed && (
                                          <p
                                            onClick={() => {
                                              removeMotif(motif.id)
                                            }}
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          >
                                            <i className='bi bi-trash fs-2'></i>
                                          </p>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={2} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                    {/* end::pagination*/}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export default MotifRefusListPage
